/** @file FNV-1a 64-bit hash of bytes as 16 hex characters, in two 32-bit halves (no BigInt). */

const PRIME_LOW = 0x1b3; // 64-bit prime = 2^40 + 0x1b3

/** FNV-1a 64 of `bytes`, lower-case hex, zero-padded to 16 characters. */
export function fnv1a64(bytes: Uint8Array): string {
  let hi = 0xcbf29ce4;
  let lo = 0x84222325;
  for (const b of bytes) {
    lo = (lo ^ b) >>> 0;
    // h * prime mod 2^64 = h * 0x1b3 + (h << 40); every partial product stays below 2^53.
    const loProduct = lo * PRIME_LOW;
    const carry = Math.floor(loProduct / 0x100000000);
    hi = (hi * PRIME_LOW + carry + lo * 256) >>> 0;
    lo = loProduct >>> 0;
  }
  return hi.toString(16).padStart(8, '0') + lo.toString(16).padStart(8, '0');
}
